import clsx from 'clsx';
import { Typography } from '@ag1/ui';
import styles from './InfoItemCol.module.scss';
import { InfoItemProps } from './InfoItemDetails.types';

const InfoItem = ({ label, value, size = 'small', className }: InfoItemProps) => {
  const classItem = clsx(styles.item, className);

  return (
    <div className={classItem}>
      <Typography
        variant="portalText"
        size={size === 'small' ? '2' : '1'}
        color="grey-1-new"
        className={styles.label}>
        {label}
      </Typography>
      <Typography
        variant={size === 'small' ? 'portalText' : 'portalSubtitle'}
        size={size === 'small' ? '1' : '2'}
        weight={size === 'small' ? '700' : '400'}
        className={styles[`value_${size}`]}>
        {value}
      </Typography>
    </div>
  );
};

export default InfoItem;
